module.exports = __webpack_public_path__ + "pin_blue.dbce18.png";